import { initializeApp }
  from "firebase/app";

import {
  getFirestore
} from "firebase/firestore";

import {
  getStorage
} from "firebase/storage";

import {
  getAuth,
  setPersistence,
  browserLocalPersistence
} from "firebase/auth";

import {
  getFunctions
} from "firebase/functions";

// =========================
// FIREBASE CONFIG
// =========================

const firebaseConfig = {

  apiKey:
    "AIzaSyCIkSgH4tpFN3cdzsMZoGS6cPePmfYpMFk",

  authDomain:
    "gestor-de-consultorio.firebaseapp.com",

  projectId:
    "gestor-de-consultorio",

  // ✅ BUCKET CORRECTO
  storageBucket:
    "gestor-de-consultorio.firebasestorage.app",

  messagingSenderId:
    "1051481497585",

  appId:
    "1:1051481497585:web:f982fb9ac99a110fb9ae50"

};

// =========================
// INIT
// =========================

const app =
  initializeApp(firebaseConfig);

// =========================
// SERVICES
// =========================

export const firebaseApp =
  app;

export const db =
  getFirestore(app);

// ✅ STORAGE NORMAL
export const storage =
  getStorage(app);

export const auth =
  getAuth(app);

export const functions =
  getFunctions(app);

// =========================
// AUTH PERSISTENCE
// =========================

setPersistence(
  auth,
  browserLocalPersistence
).catch(console.error);
